"use client";
import { ArrowUpRightIcon, UserCircle2Icon } from "lucide-react";
import Link from "next/link";

import Discussion from "@/components/discussion";
import { EventCard } from "@/components/event-card";
// import { PollFooter } from "@/components/poll/poll-footer";
import { PollViewTracker } from "@/components/poll/poll-view-tracker";
import { ResponsiveResults } from "@/components/poll/responsive-results";
import { ScheduledEvent } from "@/components/poll/scheduled-event";
import { VotingForm } from "@/components/poll/voting-form";
import { Trans } from "@/components/trans";
import { useUser } from "@/components/user-provider";
import { usePoll } from "@/contexts/poll";

const GoToApp = () => {
  const poll = usePoll();
  const { ownsObject } = useUser();
  if (!ownsObject(poll)) {
    return null;
  }

  return (
    <div className="rounded-lg border border-primary-200 bg-primary-50/75 p-2.5 text-sm sm:p-1.5">
      <div className="flex items-start justify-between sm:items-center">
        <div className="flex gap-2.5 sm:items-center lg:px-2.5">
          <UserCircle2Icon className="hidden size-4 text-primary-600 sm:block" />
          <div className="flex grow flex-col gap-x-2.5 sm:flex-row">
            <h4 className="font-medium text-primary-600">
              <Trans i18nKey="eventHostTitle" defaults="Manage Access" />
            </h4>
            <p className="text-primary-600/75">
              <Trans
                i18nKey="eventHostDescription"
                defaults="You are the creator of this poll"
              />
            </p>
          </div>
        </div>
        <Link
          className="inline-flex h-9 items-center gap-x-2.5 rounded-md px-3 font-medium text-primary-600 hover:bg-primary-200/50 active:bg-primary-200"
          href={`/poll/${poll.id}`}
        >
          <Trans i18nKey="manage" />
          <ArrowUpRightIcon className="size-4" />
        </Link>
      </div>
    </div>
  );
};

export function InvitePage() {
  const poll = usePoll();

  return (
    <div className="p-3 sm:p-6">
      <PollViewTracker pollId={poll.id} />
      <div className="mx-auto w-full max-w-4xl space-y-4">
        <GoToApp />
        <EventCard />
        <ScheduledEvent />
        <VotingForm>
          <ResponsiveResults />
        </VotingForm>
        <Discussion />
        {/* <PollFooter /> */}
      </div>
    </div>
  );
}
